import TableComponent from "../../components/organism/Table/TableComponent";
import { FC, useMemo } from "react";
import { Column } from "react-table";

interface TableExcelErrorsProps {
  dataTable: any[];
}

const TableExcelErrors: FC<TableExcelErrorsProps> = ({ dataTable }) => {
  const columns = useMemo(() => {
    const baseColumns: Column[] = [
      { Header: "Linha", accessor: "row", disableSortBy: true },
      { Header: "Coluna", accessor: "column", disableSortBy: true },
      {
        Header: "Descrição dos erros",
        accessor: "description",
        disableSortBy: true,
      },
    ];

    return baseColumns;
  }, []);

  return <TableComponent columns={columns} data={dataTable} />;
};

export default TableExcelErrors;
